// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInputArea_label__OjgBG","is_active":"TextInputArea_is_active__k9Tnb","textarea":"TextInputArea_textarea__WmRxW"};